export default __webpack_public_path__ + "static/media/photo--sm--ish-4.8af5261a.jpg";